<template>
<!--ADD LICENCE TO DO-->
  <Modal v-if="popupTriggers.addLicenseTrigger" :TogglePopup="() => TogglePopup('addLicenseTrigger')">
  <div>
    <h5>Add Licenses</h5>
    <p style="font-size: 10px; margin-top: 5px; margin-bottom: -1px">cellnumber;comment;date(dd.mm.yyyy)</p>
    <textarea style="width: 400px; font-size:10px" class="form-control" v-model="licenseInfo" placeholder=".."/>
    <button type="button" style="margin-top:5px" class="btn btn-outline-dark btn-rounded" data-mdb-ripple-color="dark" v-on:click="addLicense()">
      Add Licenses
    </button>
  </div>
  </Modal>

  <UserDetailsModal
    :visible="popupTriggers.usersButtonTrigger"
    :user="user"
    :toggle-popup="() => TogglePopup('usersButtonTrigger')"
  />

<!--MAIN-->
  <div class="col bg-light" style="width: 100%" v-if="!store.state.usersLoaded && !store.state.localUsers">
    <div class="lds-ring" style="margin-left: 50%; margin-top: 20%">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else class="col bg-light min-vh-100 users-list-view">
    <header class="users-list-header">
      <h1>Users management</h1>
      <div class="users-list-header-updated">Updated: {{ formatLastUpdated() }} <span v-if="!store.state.usersLoaded" class="users-list-header-loading"><span class="spinner-border" aria-hidden="true"></span></span></div>
    </header>
    <div class="users-list-toolbar">
      <div class="users-list-page-size">
        <label for="userEntries">Entries</label>
        <select id="userEntries" v-model="currentEntries" class="form-control form-control-sm" v-on:change="paginateEntries">
          <option v-for="se in showEntries" :key="se" :value="se">{{ se }}</option>
        </select>
      </div>
      <div class="users-list-actions">
        <button v-on:click="triggerAddLicense()" class="btn users-list-secondary">Add License</button>
        <button v-on:click="downloadCSV()" class="btn users-list-secondary">Download CSV</button>
        <button class="btn users-list-secondary" v-on:click="resetUsers()">Reset filters</button>
        <input
          class="form-control form-control-sm users-list-search"
          type="search"
          placeholder="Search.."
          v-model="searchInput"
          v-on:keydown.enter="searchEvent"
          aria-label="Search"
        />
      </div>
    </div>

    <div class="users-list-columns">
      <span class="table-filter-label">Columns</span>
      <label
        v-for="column in hideableColumns"
        :key="column.name"
        class="table-column-toggle"
      >
        <input
          :checked="isColumnVisible(column.name)"
          type="checkbox"
          class="form-check-input mt-0"
          @change="setColumnVisibility(column.name, $event.target.checked)"
        />
        <span>{{ column.text }}</span>
      </label>
    </div>

    <div class="users-list-table-wrap">
    <table id="table" :class="['table table-hover users-data-table', tableColumnVisibilityClasses]">
      <thead>
        <tr class="h6">
          <th>
            <div class="d-flex justify-content-between">
              <span>Name</span>
              <span
                v-if="sortname == 'default'"
                v-on:click.prevent="sortByColumn('name')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortname == 'desc'"
                v-on:click.prevent="sortByColumn('name')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortname == 'asc'"
                v-on:click.prevent="sortByColumn('name')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Cellnumber</span>
              <span
                v-if="sortnumber == 'default'"
                v-on:click.prevent="sortByColumn('cellnumber')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortnumber == 'desc'"
                v-on:click.prevent="sortByColumn('cellnumber')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortnumber == 'asc'"
                v-on:click.prevent="sortByColumn('cellnumber')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Country</span>
              <span
                v-if="sortcountry == 'default'"
                v-on:click.prevent="sortByColumn('country')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortcountry == 'desc'"
                v-on:click.prevent="sortByColumn('country')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortcountry == 'asc'"
                v-on:click.prevent="sortByColumn('country')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Email</span>
              <span
                v-if="sortemail == 'default'"
                v-on:click.prevent="sortByColumn('email')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortemail == 'desc'"
                v-on:click.prevent="sortByColumn('email')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortemail == 'asc'"
                v-on:click.prevent="sortByColumn('email')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Created</span>
              <span
                v-if="sortcreated == 'default'"
                v-on:click.prevent="sortByColumn('created_date')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortcreated == 'desc'"
                v-on:click.prevent="sortByColumn('created_date')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortcreated == 'asc'"
                v-on:click.prevent="sortByColumn('created_date')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Last Group</span>
              <span
                v-if="sortlastgroup == 'default'"
                v-on:click.prevent="sortByColumn('last_joined_date')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortlastgroup == 'desc'"
                v-on:click.prevent="sortByColumn('last_joined_date')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortlastgroup == 'asc'"
                v-on:click.prevent="sortByColumn('last_joined_date')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Places</span>
              <span
                v-if="sortplaces == 'default'"
                v-on:click.prevent="sortByColumn('places')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortplaces == 'desc'"
                v-on:click.prevent="sortByColumn('places')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortplaces == 'asc'"
                v-on:click.prevent="sortByColumn('places')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Created Groups</span>
              <span
                v-if="sortcreatedgroups == 'default'"
                v-on:click.prevent="sortByColumn('created_hunts')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortcreatedgroups == 'desc'"
                v-on:click.prevent="sortByColumn('created_hunts')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortcreatedgroups == 'asc'"
                v-on:click.prevent="sortByColumn('created_hunts')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>All Groups</span>
              <span
                v-if="sortallgroups == 'default'"
                v-on:click.prevent="sortByColumn('all_hunts')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortallgroups == 'desc'"
                v-on:click.prevent="sortByColumn('all_hunts')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortallgroups == 'asc'"
                v-on:click.prevent="sortByColumn('all_hunts')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Devices</span>
              <span
                v-if="sortdevices == 'default'"
                v-on:click.prevent="sortByColumn('deviceslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortdevices == 'desc'"
                v-on:click.prevent="sortByColumn('deviceslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortdevices == 'asc'"
                v-on:click.prevent="sortByColumn('deviceslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Brand</span>
              <span
                v-if="sortapp == 'default'"
                v-on:click.prevent="sortByColumn('app')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortapp == 'desc'"
                v-on:click.prevent="sortByColumn('app')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortapp == 'asc'"
                v-on:click.prevent="sortByColumn('app')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Phone</span>
              <span
                v-if="sortphone == 'default'"
                v-on:click.prevent="sortByColumn('phone')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortphone == 'desc'"
                v-on:click.prevent="sortByColumn('phone')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortphone == 'asc'"
                v-on:click.prevent="sortByColumn('phone')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Licenses</span>
              <span
                v-if="sortlicenses == 'default'"
                v-on:click.prevent="sortByColumn('licenseslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortlicenses == 'desc'"
                v-on:click.prevent="sortByColumn('licenseslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortlicenses == 'asc'"
                v-on:click.prevent="sortByColumn('licenseslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Recent License</span>
              <span
                v-if="sortrecentlicense == 'default'"
                v-on:click.prevent="sortByColumn('last_license')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortrecentlicense == 'desc'"
                v-on:click.prevent="sortByColumn('last_license')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortrecentlicense == 'asc'"
                v-on:click.prevent="sortByColumn('last_license')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Notes</span>
              <span
                v-if="sortnotes == 'default'"
                v-on:click.prevent="sortByColumn('noteslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortnotes == 'desc'"
                v-on:click.prevent="sortByColumn('noteslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortnotes == 'asc'"
                v-on:click.prevent="sortByColumn('noteslength')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>Details</th>
        </tr>

        <tr>
          <td>
            <input
              type="search"
              class="form-control search"
              placeholder=""
              aria-label="Name"
              v-model="col.name"
              v-on:keyup="filterByColumn"
            />
          </td>
          <td>
            <input
              type="search"
              class="form-control search"
              placeholder=""
              v-model="col.cellnumber"
              v-on:keyup="filterByColumn"
            />
          </td>
          <td>
            <input
              type="search"
              class="form-control search"
              :class="{ 'form-search': col.country.length > 0 }"
              list="users-country-options"
              placeholder=""
              v-model="col.country"
              v-on:input="filterByColumn"
            />
            <datalist id="users-country-options">
              <option
                v-for="countryOption in countryOptions"
                :key="countryOption"
                :value="countryOption"
              />
            </datalist>
          </td>
          <td>
            <input
              type="search"
              class="form-control search"
              placeholder=""
              v-model="col.email"
              v-on:keyup="filterByColumn"
            />
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.createddatemin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.createddatemax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.last_joineddatemin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.last_joineddatemax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.placesmin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.placesmax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.created_huntsmin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.created_huntsmax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.all_huntsmin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.all_huntsmax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.deviceslengthmin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.deviceslengthmax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>

          <td>
            <div v-if="col.app.length == 0">
              <select
                class="form-select"
                v-model="col.app"
                v-on:change="filterByColumn"
              >
                <option value="">Default</option>
                <option value=" "></option>
                <option value="Huntloc">Huntloc</option>
                <option value="Liveteam">Liveteam</option>
                <option value="Doglo">Doglo</option>
              </select>
            </div>
            <div v-else>
              <select
                class="form-select form-search"
                v-model="col.app"
                v-on:change="filterByColumn"
              >
                <option value="">Default</option>
                <option value=" "></option>
                <option value="Huntloc">Huntloc</option>
                <option value="Liveteam">Liveteam</option>
                <option value="Doglo">Doglo</option>
              </select>
            </div>
          </td>
          <td>
            <div v-if="col.phone.length == 0">
              <select
                class="form-select"
                v-model="col.phone"
                v-on:change="filterByColumn"
              >
                <option value="">Default</option>
                <option value=" "></option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
              </select>
            </div>
            <div v-else>
              <select
                class="form-select form-search"
                v-model="col.phone"
                v-on:change="filterByColumn"
              >
                <option value="">Default</option>
                <option value=" "></option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
              </select>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.licenseslengthmin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.licenseslengthmax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.licenseslastdatemin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.licenseslastdatemax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td>
            <div>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.noteslengthmin"
                  v-on:keyup="filterByColumn"
              /></span>
              <span class="d-flex justify-content-center bold">to</span>
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.noteslengthmax"
                  v-on:keyup="filterByColumn"
              /></span>
            </div>
          </td>
          <td></td>
        </tr>
      </thead>

      <tbody>
        <tr v-for="td in tableData" :key="td">
          <td>{{ td.name }}</td>

          <td>{{ td.cellnumber }}</td>

          <td>{{ td.country }}</td>

          <td>
            <a v-if="isValidEmail(td.email)" :href="getMailtoHref(td.email)">{{ td.email }}</a>
            <span v-else>{{ td.email }}</span>
          </td>

          <td>{{ td.created_date }}</td>

          <td>{{ td.last_joined_date }}</td>

          <td>{{ td.places }}</td>

          <td>{{ td.created_hunts }}</td>

          <td>{{ td.all_hunts }}</td>

          <td>{{ td.deviceslength }}</td>

          <td>
            <span :class="getBrandClass(td.app)">{{ td.app }}</span>
          </td>

          <td>{{ td.phone }}</td>

          <td>{{ td.licenseslength }}</td>

          <td>
            <div
              v-if="new Date(td.last_license_date).getTime() < new Date().getTime()"
              v-bind:class="{ invalid: true }"
            >
              {{ td.last_license_date }}
            </div>
            <div
              v-else-if="
                new Date(td.last_license_date).getTime() <
                new Date().getTime() + 2629800000
              "
              v-bind:class="{ invalidSoon: true }"
            >
              {{ td.last_license_date }}
            </div>
            <div v-else>{{ td.last_license_date }}</div>
          </td>

          <td>{{ td.noteslength }}</td>

          <td class="users-details-cell">
            <svg
              v-on:click="userInfo(td)"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="currentColor"
              class="bi bi-info-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
              />
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <div class="d-flex flex-row justify-content-between w-100" id="pagination">
      <div class="pt-2" style="font-size: 12px; display: block">
        Show {{ showInfo.from }} to {{ showInfo.to }} of
        {{ showInfo.of }} entries
      </div>
      <div style="font-size: 10px">
        <ul class="list-group list-group-horizontal mb-1">
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === 1 },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              v-on:click.prevent="(currentPage = 1), paginateEntries()"
              >First</a
            >
          </li>
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === 1 },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              v-on:click.prevent="
                currentPage < 1 ? (currentPage = 1) : (currentPage -= 1),
                  paginateEntries()
              "
              >Prev</a
            >
          </li>
          <li
            v-for="pagi in showPagination"
            :key="pagi"
            :class="[
              'list-group-item border px-2',
              { ellipsis: pagi === '...', active: pagi === currentPage },
            ]"
          >
            <a
              href="#"
              class="nav-link bg-white text-dark"
              v-on:click.prevent="paginateEvent(pagi)"
              >{{ pagi }}</a
            >
          </li>
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === allPages },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              v-on:click.prevent="
                currentPage > allPages
                  ? (currentPage = allPages)
                  : (currentPage += 1),
                  paginateEntries()
              "
              >Next</a
            >
          </li>
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === allPages },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              v-on:click.prevent="(currentPage = allPages), paginateEntries()"
              >Last</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "alga-js"
import axios from "axios"
import { ref } from "vue"
import Modal from "@/components/Modal.vue"
import UserDetailsModal from "@/components/UserDetailsModal.vue"
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { inject } from 'vue'
import { mapState } from 'vuex'
import { API_ENDPOINTS } from '@/config/api'

export default {
  name: "UsersTable",
  components: {
    Modal,
    UserDetailsModal,
  },
  setup() {
    const store = inject('store')
    const popupTriggers = ref({
      usersButtonTrigger: false,
      addLicenseTrigger: false
    });

    const TogglePopup = (trigger) => {
      popupTriggers.value[trigger] = !popupTriggers.value[trigger];
    };
    return {
      Modal,
      popupTriggers,
      TogglePopup,
      store
    }
  },
  mounted() {
    if(!this.store.state.usersLoaded){
      this.$store.dispatch('loadUsers')
    }
  },
  data() {
    return {
      sortname: "default",
      sortnumber: "default",
      sortcountry: "default",
      sortemail: "default",
      sortcreated: "default",
      sortlastgroup: "default",
      sortplaces: "default",
      sortcreatedgroups: "default",
      sortallgroups: "default",
      sortdevices: "default",
      sortapp: "default",
      sortphone: "default",
      sortlicenses: "default",
      sortrecentlicense: "default",
      sortnotes: "default",
      tablehover: false,
      notetext: "",
      sort: "default",
      portalPIN: "",
      togglenotes: false,
      togglelicenses: false,
      toggledevices: false,
      invalidSoon: false,
      invalid: false,
      title: "Users",
      loaded: false,
      licenseInfo: "",
      givenDate: "",
      dateMillis: 0,
      addedLicenseNumbers: [],
      csvData: [],
      togglenewlicense: false,
      userLicenseDate: 0,
      last_updated: 0,
      
      //Add license in detail tab for single user
      addSingleUserLicense: false,
      singleUserDate: 0,
      singleUserComment: "",

      columns: [
        { name: "name", text: "Name" },
        { name: "cellnumber", text: "Cellnumber" },
        { name: "country", text: "Country" },
        { name: "email", text: "Email" },
        { name: "created_date", text: "Created" },
        { name: "last_joined_date", text: "Last Hunt" },
        { name: "places", text: "Places" },
        { name: "created_hunts", text: "Created Hunts" },
        { name: "all_hunts", text: "All Hunts" },
        { name: "deviceslength", text: "Devices" },
        { name: "app", text: "Brand" },
        { name: "phone", text: "Phone" },
        { name: "licenseslength", text: "Licenses" },
        { name: "last_license", text: "Recent License" },
        { name: "noteslength", text: "Notes" },
        { name: "details", text: "Details" },
      ],
      columnVisibility: {
        cellnumber: true,
        country: true,
        email: true,
        created_date: true,
        last_joined_date: true,
        places: true,
        created_hunts: true,
        all_hunts: true,
        deviceslength: true,
        app: true,
        phone: true,
        licenseslength: true,
        last_license: true,
        noteslength: true,
        details: true,
      },
      entries: [],
      user: {
        teamsinfo: [],
        licenses: [],
        devices: [],
        notes: []
      },
      team: [],
      teamsinfo: [],
      defaultentries: [],
      filterentries: [],
      showEntries: [1, 5, 10, 15, 25, 50, 100, 250, 500, 1000, 1500],
      currentEntries: 50,
      filteredEntries: [],
      currentPage: 1,
      allPages: 1,
      searchInput: "",
      searchEntries: [],
      col: {
        name: "",
        cellnumber: "",
        country: "",
        email: "",
        created_date: "",
        last_joined_date: "",
        places: "",
        created_hunts: "",
        all_hunts: "",
        deviceslengthmin: "",
        deviceslengthmax: "",
        app: "",
        phone: "",
        licenseslength: "",
        last_license: "",
        noteslength: "",
      },
      sortcol: {
        name: "",
        cellnumber: "",
        country: "",
        email: "",
        created_date: "",
        last_joined_date: "",
        places: "",
        created_hunts: "",
        all_hunts: "",
        deviceslengthmin: "",
        deviceslengthmax: "",
        app: "",
        phone: "",
        licenseslength: "",
        last_license: "",
        noteslength: "",
      },
    };
  },
  computed: {
    showInfo() {
      return $.array.pageInfo(
        this.getCurrentEntries(),
        this.currentPage,
        this.currentEntries
      );
    },
    showPagination() {
      return $.array.pagination(this.allPages, this.currentPage, 3);
    },
    tableColumns() {
      return this.columns;
    },
    hideableColumns() {
      return this.columns.slice(1);
    },
    tableColumnVisibilityClasses() {
      return this.hideableColumns
        .filter((column) => this.columnVisibility[column.name] === false)
        .map((column) => `hide-column-${column.name}`);
    },
    tableData() {
      return this.filteredEntries;
    },
    countryOptions() {
      const sourceEntries =
        Array.isArray(this.defaultentries) && this.defaultentries.length > 0
          ? this.defaultentries
          : this.entries

      return Array.from(
        new Set(
          sourceEntries
            .map((entry) => entry.country)
            .filter(
              (country) =>
                typeof country === "string" && country.trim().length > 0
            )
        )
      ).sort((firstCountry, secondCountry) =>
        firstCountry.localeCompare(secondCountry)
      )
    },
    computed: mapState(['users']),
  },
  created() {
    this.getLocalUsers()
    this.getUsers()
  },
  methods: {
    formatLastUpdated() {
      const value = String(this.last_updated || '').trim()
      if (!value) return '-'
      if (/\d{1,2}\.\d{1,2}\.\d{4}/.test(value)) return value

      return `${new Date().toLocaleDateString('et-EE')} ${value}`
    },
    isColumnVisible(columnName) {
      return this.columnVisibility[columnName] !== false
    },
    setColumnVisibility(columnName, isVisible) {
      this.columnVisibility[columnName] = isVisible
    },
    getBrandClass(brand) {
      const normalizedBrand = String(brand || "").trim()

      if (normalizedBrand === "Huntloc") return "user-brand-huntloc"
      if (normalizedBrand === "Doglo") return "user-brand-doglo"

      return ""
    },
    isValidEmail(email) {
      if (typeof email !== "string") return false
      const trimmedEmail = email.trim()
      if (trimmedEmail.length === 0) return false
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)
    },
    getMailtoHref(email) {
      return `mailto:${String(email).trim()}`
    },
    //GET REQUESTS_________________________________________________________________
    getLocalUsers(){
      if(localStorage.length > 1){
        let storage = []
        for(let i = 0; i < 2002; i++){
          let user = JSON.parse(localStorage.getItem(i))
          storage.push(user)
        }
        let teamsAPI = API_ENDPOINTS.TIW_API + "/team/list_all"
        axios.get(teamsAPI).then((data) => {
          this.team = data.data
          for (let i = 0; i < this.team.length; i++) {
            this.team[i].phoneNumber = ""
            this.team[i].ownerName = ""
            this.team[i].teamName = ""
            if (this.team[i].permissions.length != 0 || this.team[i].permissions.length != null) {
              for (let j = 0; j < this.team[i].permissions.length; j++) {
                if (this.team[i].permissions[j].permission == "owner") {
                  this.team[i].phoneNumber = this.team[i].permissions[j].user.phoneNumber
                  this.team[i].ownerName = this.team[i].permissions[j].user.name
                  break
                }
              }
              if (this.team[i].name != null) this.team[i].teamName = this.team[i].name
            }
          }
        })
        this.last_updated = localStorage.getItem('last_updated')
        this.entries = storage
        this.filterentries = this.entries
        this.defaultentries = this.entries
        this.csvData = this.entries
        this.paginateData(this.entries)
        this.allPages = $.array.pages(this.entries, this.currentEntries)
      }
    },
    async getUsers() {
      if(this.store.state.usersLoaded){
        let teamsAPI = API_ENDPOINTS.TIW_API + "/team/list_all"
        axios.get(teamsAPI).then((data) => {
          this.team = data.data
          for (let i = 0; i < this.team.length; i++) {
            this.team[i].phoneNumber = ""
            this.team[i].ownerName = ""
            this.team[i].teamName = ""
            if (this.team[i].permissions.length != 0 || this.team[i].permissions.length != null) {
              for (let j = 0; j < this.team[i].permissions.length; j++) {
                if (this.team[i].permissions[j].permission == "owner") {
                  this.team[i].phoneNumber = this.team[i].permissions[j].user.phoneNumber
                  this.team[i].ownerName = this.team[i].permissions[j].user.name
                  break
                }
              }
              if (this.team[i].name != null) this.team[i].teamName = this.team[i].name
            }
          }
          this.entries = this.store.state.users
          this.filterentries = this.entries
          this.defaultentries = this.entries
          this.csvData = this.entries
          this.paginateData(this.entries)
          this.allPages = $.array.pages(this.entries, this.currentEntries)
          this.searchEvent()
          this.filterByColumn()
          this.last_updated = localStorage.getItem('last_updated')
        })
      }
      else{
        setTimeout(() => {  this.getUsers()  }, 10000)
      }
    },
    userInfo(user) {
      this.user = user
      let apiURL = API_ENDPOINTS.TIW_API + "/activity/" + user.cellnumber
      axios.get(apiURL).then((res) => {
        this.user.notes = res.data
        this.user.teamsinfo = []
        this.teamsinfo = []
          for(let i = 0; i < this.team.length; i++){
            for(let j = 0; j < this.team[i].permissions.length; j++){
              if(this.user.cellnumber == this.team[i].permissions[j].user.phoneNumber){
                let teamname = this.team[i].teamName
                let role = this.team[i].permissions[j].permission
                let name = this.team[i].ownerName
                let number = this.team[i].phoneNumber
                this.teamsinfo.push({
                  teamName: teamname,
                  teamRole: role,
                  teamOwner: name,
                  teamOwnerNumber: number
              })
              }
            }
          }
          this.user.teamsinfo = this.teamsinfo
          this.TogglePopup("usersButtonTrigger")
      })
    }, 
    async loginPortal(user) {
      const pin = String(this.portalPIN || "").trim()
      const cell = String(user?.cellnumber || "").trim()

      if (!pin) {
        alert("Please enter PIN.")
        return
      }

      if (!cell) {
        alert("User phone number is missing.")
        return
      }

      const apiURL = API_ENDPOINTS.TIW_API + "/portal-auth/" + encodeURIComponent(cell) + "/" + encodeURIComponent(pin)
      try {
        await axios.get(apiURL)
        alert("User signed in")
        this.portalPIN = ""
      } catch (error) {
        const message = error?.response?.data?.message || error?.response?.data?.error || "Portal login failed."
        alert(message)
      }
    },
    //POST REQUESTS_________________________________________________________________
    submitSingleLicense(user) {
      let now = Date.now()
      let email = firebase.auth().currentUser.email
      let name = email.split('@')[0].split('.')[0]
      name = name.charAt(0).toUpperCase() + name.slice(1)
      let comment = document.getElementById("newLicenseComment")
      let time = new Date(this.userLicenseDate)
      let body = {
        created : now,
        creator : name,
        comment : comment.value,
        valid : true,
        validUntil : time.getTime(),
        phoneNumber : user.cellnumber
      }
      let backendAPI = API_ENDPOINTS.TIW_API + "/rest/lic"
      axios.post(backendAPI, body).then((res) => {
        body.validuntil = body.validUntil
        user.licenses.push(body)
        alert("License added to "+user.cellnumber+" until "+this.userLicenseDate)
        this.togglenewlicense = !this.togglenewlicense
      })
    },
    addNotes(user) {
      let note = document.getElementById("userNoteInput")
      if (note.value != "") {
        let body = {
          name: "admin_note",
          created: Date.now(),
          data: { text: note.value },
          dataJsonStr: null,
        }
        let apiURL = API_ENDPOINTS.TIW_API + "/activity/" + user.cellnumber
        axios.post(apiURL, body).then((res) => {
          alert("Note has been added")
          document.getElementById("userNoteInput").value = ""
          user.notes.push(body)

        })
      }
    },
    //TOGGLES_______________________________________________________________
    toggleUserLicense() {
      this.togglenewlicense = !this.togglenewlicense
      let def = Date.now() + 31556952000
      let y = new Date(def).getFullYear()
      let m = ("0" + (new Date(def).getMonth() + 1)).slice(-2)
      let d = ("0" + (new Date(def).getDate())).slice(-2)
      this.userLicenseDate = y+"-"+m+"-"+d
    },
    triggerAddLicense(){
      this.TogglePopup("addLicenseTrigger")
      setTimeout(() => {}, 1)
    },
    //CSV Add Licenses
    addLicense(){
      let lines = this.licenseInfo.split('\n')
      let now = Date.now()
      let email = firebase.auth().currentUser.email
      let name = email.split('@')[0].split('.')[0]
      name = name.charAt(0).toUpperCase() + name.slice(1)
      
      //TOCHECK
      for(let i = 0; i < lines.length; i++){
        let line = lines[i]
        if(line.length >= 1){
          let number = line.split(";")[0]
          let comment = line.split(";")[1]
          let date = line.split(";")[2]
          let d = date.split(".")[0]
          let m = date.split(".")[1] 
          let y = date.split(".")[2] 
          date = y+"-"+m+"-"+d
          date = new Date(date)
          let body = {
            created : now,
            creator : name,
            comment : comment,
            valid: true,
            validUntil : date.getTime(),
            phoneNumber: number
          }
          let asi = this.postLicense(body)
          if(asi){
            body.validuntil = body.validUntil
          
          this.addedLicenseNumbers.push(number)
          for(let i = 0; i < this.entries.length; i++) if(this.entries[i].cellnumber == number) this.entries[i].licenses.push(body)
          }
        }
      }
      let added = ""
      for(let i = 0; i < this.addedLicenseNumbers.length; i++) added += this.addedLicenseNumbers[i] + ", "
      added.slice(0, -2)
      alert("Licenses added to: "+added)
      this.licenseInfo = ""
      this.triggerAddLicense()
    },
    async postLicense(body) {
      let backendAPI = API_ENDPOINTS.TIW_API + "/rest/lic"
      axios.post(backendAPI, body).then((res) => {
        return true
      })
    },
    //OTHER FUNCTIONS
    toPortal() {
      let url = API_ENDPOINTS.PORTAL_API
      const a = document.createElement("a")
      a.setAttribute("hidden", "")
      a.setAttribute("href", url)
      a.setAttribute("target", "_blank")
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    downloadCSV() {
        const rows = []
        const data = this.csvData
        const headers = ["name", "cellnumber", "country", "email", "created_date", "last_joined_date", "places", "created_hunts", "all_hunts", "deviceslength", "app", "phone", "licenseslength", "last_license_date"]
        rows.push(headers.join(";"))

        for (const row of data) {
          const values = headers.map((header) => {
            const escaped = ("" + row[header]).replace(/"/g, '\\"')
            if (`"${escaped}"` == '"null"') return '""'
            else return `"${escaped}"`
          })
          rows.push(values.join(";"))
        }
        let csv = rows.join("\n")

        const blob = new Blob([csv], { type: "text/csv" })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.setAttribute("hidden", "")
        a.setAttribute("href", url)
        a.setAttribute("download", "Users.csv")
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    },
    toggleDevices() {
      this.toggledevices = !this.toggledevices;
    },
    toggleLicenses() {
      this.togglelicenses = !this.togglelicenses;
    },
    toggleNotes() {
      this.togglenotes = !this.togglenotes;
    },
    resetUsers() {
      this.resetSortIcon();
      this.resetSortLogic;
      this.entries = this.defaultentries;
      this.filterentries = this.defaultentries;
      this.currentPage = 1;
      this.searchInput = "";
      (this.col = {
        name: "",
        cellnumber: "",
        country: "",
        email: "",
        created_date: "",
        last_joined_date: "",
        places: "",
        created_hunts: "",
        all_hunts: "",
        deviceslengthmin: "",
        deviceslengthmax: "",
        app: "",
        phone: "",
        licenseslength: "",
        last_license: "",
        noteslength: "",
      }),
        this.paginateEntries();
    },
    paginateEntries() {
      if (this.searchInput.length >= 1) {
        this.searchEntries = $.array.search(this.entries, this.searchInput);
        this.paginateData(this.searchEntries);
      } else {
        this.searchEntries = [];
        this.paginateData(this.entries);
      }
    },
    paginateEvent(page) {
      this.currentPage = page;
      this.paginateEntries();
    },
    searchEvent() {
      this.resetSortIcon();
      this.resetSortLogic;
      this.currentPage = 1;
      this.paginateEntries()
    },
    paginateData(data) {
      this.filteredEntries = $.array.paginate(
        data,
        this.currentPage,
        this.currentEntries
      );
      this.allPages = $.array.pages(data, this.currentEntries);
      this.csvData = this.filteredEntries
    },
    getCurrentEntries() {
      return this.searchEntries.length <= 0 ? this.entries : this.searchEntries;
    },
    filter(filterObj) {
      let filteredArray = Array.from(this.getCurrentEntries());
      for (let [key, val] of Object.entries(filterObj, "", 0)) {
        const filterfromArr = filteredArray.filter((obj) => {
          if (key in obj) {
            //filtering strings
            if (!key.includes("min") && !key.includes("max")) {
              if (obj[key] == Number(val)) {
                return true;
              } else if (
                obj[key] &&
                obj[key].toLowerCase().includes(val.toLowerCase())
              ) {
                return true;
              }
            }
            //filtering integers and dates
            else if (key.includes("min") || key.includes("max")) {
              //dates
              if (key.includes("date")) {
                if (val.length >= 4) {
                  let date, yyyy, valms, value;
                  if (val.includes("-")) {
                    valms = val.split("-");
                    yyyy = valms[0];
                    if (valms[1] != "" && valms[1] != null) {
                      let mm;
                      if (valms[1].length < 2) {
                        mm = "0" + valms[1];
                      } else {
                        mm = valms[1];
                      }
                      if (valms[2] != "" && valms[2] != null) {
                        let dd;
                        if (valms[2].length < 2) {
                          dd = "0" + valms[2];
                        } else {
                          dd = valms[2];
                        }
                        date = new Date([yyyy, mm, dd].join("-"));
                      } else {
                        date = new Date([yyyy, mm].join("-"));
                      }
                    } else {
                      date = new Date(yyyy);
                    }
                  } else {
                    yyyy = val;
                    date = new Date(yyyy);
                  }
                  let object = Number(obj[key]);
                  if (key.includes("min")) {
                    value = date.getTime() - 7200000;
                    if (object >= value) {
                      return true;
                    }
                  } else if (key.includes("max")) {
                    value = date.getTime() + 79199999;
                    if (object <= value) {
                      return true;
                    }
                  }
                }
              }
              //integers
              else {
                let object = Number(obj[key]);
                let value = Number(val);
                if (key.includes("min")) {
                  if (object >= value) {
                    return true;
                  }
                } else if (key.includes("max")) {
                  if (object <= value) {
                    return true;
                  }
                }
              }
            }
          }
          return false;
        });
        filteredArray = filterfromArr;
      }
      this.csvData = filteredArray
      return filteredArray;
    },
    filterByColumn() {
      this.resetSortIcon();
      this.currentPage = 1;
      this.entries = this.defaultentries;
      const filterCol = $.object.removeBy(this.col, "");
      let filterData = this.getCurrentEntries();

      if (Object.entries(filterCol).length >= 1) {
        filterData = this.filter(filterCol);
      }
      this.entries = filterData;
      this.filterentries = this.entries;
      this.resetSortLogic();
      this.paginateData(this.entries);
      this.allPages = $.array.pages(this.entries, this.currentEntries);
    },
    resetSortIcon() {
      //Resetting sorting icons
      (this.sortname = "default"),
        (this.sortnumber = "default"),
        (this.sortcountry = "default"),
        (this.sortemail = "default"),
        (this.sortcreated = "default"),
        (this.sortlastgroup = "default"),
        (this.sortplaces = "default"),
        (this.sortcreatedgroups = "default"),
        (this.sortallgroups = "default"),
        (this.sortdevices = "default"),
        (this.sortapp = "default"),
        (this.sortphone = "default"),
        (this.sortlicenses = "default"),
        (this.sortrecentlicense = "default"),
        (this.sortnotes = "default");
    },
    resetSortLogic() {
      //Resetting sorting logic to default
      this.sortcol["name"] = "";
      this.sortcol["cellnumber"] = "";
      this.sortcol["country"] = "";
      this.sortcol["email"] = "";
      this.sortcol["created_date"] = "";
      this.sortcol["last_joined_date"] = "";
      this.sortcol["places"] = "";
      this.sortcol["created_hunts"] = "";
      this.sortcol["all_hunts"] = "";
      this.sortcol["deviceslength"] = "";
      this.sortcol["app"] = "";
      this.sortcol["phone"] = "";
      this.sortcol["licenseslength"] = "";
      this.sortcol["last_license"] = "";
      this.sortcol["noteslength"] = "";
    },
    sortByColumn(column) {
      let sortedEntries = this.getCurrentEntries();
      let sortedColumn = this.sortcol[column];
      if (sortedColumn === "") {
        this.sortcol[column] = "asc";
        if (column == "name") {
          this.sortname = "asc";
        } else if (column == "cellnumber") {
          this.sortnumber = "asc";
        } else if (column == "country") {
          this.sortcountry = "asc";
        } else if (column == "email") {
          this.sortemail = "asc";
        } else if (column == "created_date") {
          this.sortcreated = "asc";
        } else if (column == "last_joined_date") {
          this.sortlastgroup = "asc";
        } else if (column == "places") {
          this.sortplaces = "asc";
        } else if (column == "created_hunts") {
          this.sortcreatedgroups = "asc";
        } else if (column == "all_hunts") {
          this.sortallgroups = "asc";
        } else if (column == "deviceslength") {
          this.sortdevices = "asc";
        } else if (column == "app") {
          this.sortapp = "asc";
        } else if (column == "phone") {
          this.sortphone = "asc";
        } else if (column == "licenseslength") {
          this.sortlicenses = "asc";
        } else if (column == "last_license") {
          this.sortrecentlicense = "asc";
        } else if (column == "noteslength") {
          this.sortnotes = "asc";
        }
        sortedEntries = $.array.sortBy(this.getCurrentEntries(), column, "asc");
        this.entries = sortedEntries;
      } else if (sortedColumn === "asc") {
        this.sortcol[column] = "desc";
        if (column == "name") {
          this.sortname = "desc";
        } else if (column == "cellnumber") {
          this.sortnumber = "desc";
        } else if (column == "country") {
          this.sortcountry = "desc";
        } else if (column == "email") {
          this.sortemail = "desc";
        } else if (column == "created_date") {
          this.sortcreated = "desc";
        } else if (column == "last_joined_date") {
          this.sortlastgroup = "desc";
        } else if (column == "places") {
          this.sortplaces = "desc";
        } else if (column == "created_hunts") {
          this.sortcreatedgroups = "desc";
        } else if (column == "all_hunts") {
          this.sortallgroups = "desc";
        } else if (column == "deviceslength") {
          this.sortdevices = "desc";
        } else if (column == "app") {
          this.sortapp = "desc";
        } else if (column == "phone") {
          this.sortphone = "desc";
        } else if (column == "licenseslength") {
          this.sortlicenses = "desc";
        } else if (column == "last_license") {
          this.sortrecentlicense = "desc";
        } else if (column == "noteslength") {
          this.sortnotes = "desc";
        }
        sortedEntries = $.array.sortBy(
          this.getCurrentEntries(),
          column,
          "desc"
        );
        this.entries = sortedEntries;
      } else if (sortedColumn === "desc") {
        this.sortcol[column] = "";
        if (column == "name") {
          this.sortname = "default";
        } else if (column == "cellnumber") {
          this.sortnumber = "default";
        } else if (column == "country") {
          this.sortcountry = "default";
        } else if (column == "email") {
          this.sortemail = "default";
        } else if (column == "created_date") {
          this.sortcreated = "default";
        } else if (column == "last_joined_date") {
          this.sortlastgroup = "default";
        } else if (column == "places") {
          this.sortplaces = "default";
        } else if (column == "created_hunts") {
          this.sortcreatedgroups = "default";
        } else if (column == "all_hunts") {
          this.sortallgroups = "default";
        } else if (column == "deviceslength") {
          this.sortdevices = "default";
        } else if (column == "app") {
          this.sortapp = "default";
        } else if (column == "phone") {
          this.sortphone = "default";
        } else if (column == "licenseslength") {
          this.sortlicenses = "default";
        } else if (column == "last_license") {
          this.sortrecentlicense = "default";
        } else if (column == "noteslength") {
          this.sortnotes = "default";
        }
        this.entries = this.filterentries;
      }
      this.paginateData(this.entries);
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
html,
body {
  max-width: 100%;
}
th,
td,
tr,
select,
input,
body {
  font-size: 10px;
}
th {
  font-weight: normal;
}
button {
  font-size: 10px;
}
.table-filter-label,
.table-column-toggle {
  font-size: 10px;
}
.table-column-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.users-list-view { padding: 4px 18px 18px; color: #202629; }
.users-list-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin: 0 -18px 18px; padding: 20px 22px; border-left: 4px solid #f56600; border-radius: 0 0 9px 9px; background: #202629; color: #fff; }
.users-list-header h1 { margin: 0; font-size: 22px; font-weight: 700; }
.users-list-header-updated { display: flex; align-items: center; gap: 6px; color: #c8d0d3; font-size: 11px; font-style: italic; }
.users-list-header-loading { display: inline-flex; }
.users-list-header-loading .spinner-border { width: 11px; height: 11px; border-width: 2px; }
.users-list-toolbar { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin-bottom: 12px; padding: 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.users-list-page-size { display: flex; align-items: center; gap: 7px; }
.users-list-page-size label { color: #40545e; font-size: 10px; font-weight: 700; text-transform: uppercase; }
.users-list-page-size select { width: 64px; font-size: 10px; font-weight: 700; }
.users-list-actions { display: flex; flex: 1; flex-wrap: wrap; justify-content: flex-end; gap: 7px; }
.users-list-actions .btn { margin: 0; font-size: 10px; }
.users-list-secondary { border: 1px solid #d7dfe2; background: #fff; color: #202629; }
.users-list-secondary:hover { border-color: #f56600; color: #f56600; }
.users-list-search { width: 180px; height: 29px; color: #202629; }
.users-list-columns { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 12px; margin-bottom: 12px; padding: 10px 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.users-list-columns .table-filter-label { margin: 0; color: #40545e; font-weight: 700; text-transform: uppercase; }
.users-list-table-wrap { overflow-x: auto; border: 1px solid #e1e5e6; border-radius: 9px; background: #fff; }
.users-data-table { min-width: 1450px; margin-bottom: 0; }
.users-data-table thead { background: #f1f4f5; }
.users-data-table th, .users-data-table td { padding: 9px 10px; vertical-align: middle; border-color: #e1e5e6; }
.users-data-table thead th { color: #40545e; font-size: 10px; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; }
.users-data-table tbody tr:last-child > * { border-bottom: 0; }
.users-details-cell { text-align: center; }
@media (max-width: 700px) { .users-list-view { padding: 4px 10px 12px; } .users-list-header { margin: 0 -10px 14px; padding: 16px; } .users-list-actions { justify-content: flex-start; } .users-list-search { width: 100%; } }
.invalidSoon {
  background-color: yellow;
}
.invalid {
  background-color: salmon;
}
.bi:hover {
  color: darkblue;
  cursor: pointer;
}
.search {
  font-weight: bold;
  color: orangered;
}
.form-search {
  background-color: salmon;
  font-weight: bold;
}
.user-brand-huntloc,
.user-brand-doglo {
  display: inline-block;
  min-width: 72px;
  padding: 2px 6px;
  border-radius: 999px;
  text-align: center;
}
.user-brand-huntloc {
  background-color: #ff9a00;
  color: #000;
}
.user-brand-doglo {
  background-color: #000;
  color: #fff;
}
.users-data-table.hide-column-cellnumber tr > :nth-child(2),
.users-data-table.hide-column-country tr > :nth-child(3),
.users-data-table.hide-column-email tr > :nth-child(4),
.users-data-table.hide-column-created_date tr > :nth-child(5),
.users-data-table.hide-column-last_joined_date tr > :nth-child(6),
.users-data-table.hide-column-places tr > :nth-child(7),
.users-data-table.hide-column-created_hunts tr > :nth-child(8),
.users-data-table.hide-column-all_hunts tr > :nth-child(9),
.users-data-table.hide-column-deviceslength tr > :nth-child(10),
.users-data-table.hide-column-app tr > :nth-child(11),
.users-data-table.hide-column-phone tr > :nth-child(12),
.users-data-table.hide-column-licenseslength tr > :nth-child(13),
.users-data-table.hide-column-last_license tr > :nth-child(14),
.users-data-table.hide-column-noteslength tr > :nth-child(15),
.users-data-table.hide-column-details tr > :nth-child(16) {
  display: none !important;
}
/* clears the 'X' from Internet Explorer */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
.lds-ring-sm {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}
.lds-ring-sm div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  border: 4px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring-sm div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring-sm div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring-sm div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 768px) {
}
</style>
